<template>
  <v-btn
    class="white--text text-none headline linear-button-background font-weight-bold pl-12 pr-12"
    @click="buttonClicked"
    depressed
    rounded
    ripple
    large
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: "Pricing",
  methods: {
    buttonClicked() {
      this.$emit("click");
    }
  }
};
</script>

<style scoped>
.linear-button-background {
  background: linear-gradient(to right, #2ccca0, #1ae9b0) !important;
}

.button-width {
  width: 100%;
}
</style>
